/**
 * @generated SignedSource<<a3bd52374d1ec97316a63f6240021e66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementComments_member_Query$variables = {
  id: string;
};
export type AnnouncementComments_member_Query$data = {
  readonly member: {
    readonly email?: string;
    readonly id?: string;
    readonly name?: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null;
};
export type AnnouncementComments_member_Query = {
  response: AnnouncementComments_member_Query$data;
  variables: AnnouncementComments_member_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementComments_member_Query",
    "selections": [
      {
        "alias": "member",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatar_member"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserHandle_member"
              }
            ],
            "type": "Member",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementComments_member_Query",
    "selections": [
      {
        "alias": "member",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roles",
                "storageKey": null
              }
            ],
            "type": "Member",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a0e308dc22a5e5585780a4ef9fada36",
    "id": null,
    "metadata": {},
    "name": "AnnouncementComments_member_Query",
    "operationKind": "query",
    "text": "query AnnouncementComments_member_Query(\n  $id: ID!\n) {\n  member: node(id: $id) {\n    __typename\n    ... on Member {\n      id\n      name\n      email\n      ...UserAvatar_member\n      ...UserHandle_member\n    }\n    id\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "618fdcc1e414c3214bfb4a82baed9ce1";

export default node;
